import EdCardComponent from './ed-card/ed-card.component.vue';
import EdCardsLoadingComponent from './ed-cards-loading/ed-cards-loading.component.vue';

export const CardsComponents = {
  EdCardComponent,
  EdCardsLoadingComponent,
}